
import AppProductInfo from "@/components/products/ProductInfo.vue";
import { Product } from "@/models/base";
import { ProductService } from "@/services/product-service";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			product: null as Product | null,
		};
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		},
	},
	methods: {
		onCancel() {
			this.$router.push("/products");
		},
	},
	async mounted() {
		let id = parseInt(this.$route.params.id);
		ToolbarService.title = this.$ct("title-info");
		this.product = await ProductService.getProduct(id);
	},
	components: {
		AppProductInfo
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
	beforeRouteLeave(from, to, next){
		next();
		let product = this.product as Product;
		this.product = new Product();
		ProductService.lastOpenedItem.setLastOpenedItem(product.getLastOpenedJSON());
	}
});
